import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-mini'

const SECOND_IN_MS = 1000
const MINUTE_IN_MS = 60000
const HOUR_IN_MS = 3.6e6
const DAY_IN_MS = 8.64e7
const WEEK_IN_MS = 6.048e8

const SECOND_LABEL = 's'
const MINUTE_LABEL = 'm'
const HOUR_LABEL = 'h'
const DAY_LABEL = 'd'

// const SECOND_LONG_LABEL = 'sec'
// const MINUTE_LONG_LABEL = 'min'
// const HOUR_LONG_LABEL = 'hour'
// const DAY_LONG_LABEL = 'day'

const CURRENT_LABEL = 'now'

/**
 * Generates a label based on difference in time
 * @param {number} diff - difference in dates in milliseconds
 * @param {moment} momentDate - moment date
 * @param {boolean} futureDate - if is future date
 * @returns {string}
 */
const _generateTimestampLabel = (diff, momentDate, futureDate, futureLabel) => {
  let label = ''
  //
  if (diff >= WEEK_IN_MS) {
    // after 7 days, have in format of MMM, d
    label = momentDate.format('MMM Do YYYY')
  } else if (diff < WEEK_IN_MS && diff >= DAY_IN_MS) {
    // day
    label = `${Math.round(diff / DAY_IN_MS)}${DAY_LABEL}`
  } else if (diff < DAY_IN_MS && diff >= HOUR_IN_MS) {
    // hour
    label = `${Math.round(diff / HOUR_IN_MS)}${HOUR_LABEL}`
  } else if (diff < HOUR_IN_MS && diff >= MINUTE_IN_MS) {
    // minute
    label = `${Math.round(diff / MINUTE_IN_MS)}${MINUTE_LABEL}`
  } else if (diff < MINUTE_IN_MS && diff >= SECOND_IN_MS) {
    // second
    label = `${Math.round(diff / SECOND_IN_MS)}${SECOND_LABEL}`
  } else {
    // now OR future date
    if (futureDate) {
      const absDiff = Math.abs(diff)

      if (absDiff >= WEEK_IN_MS) {
        // after 7 days, have in format of MMM, d
        label = momentDate.format('MMM D')
      } else if (absDiff < WEEK_IN_MS && absDiff >= DAY_IN_MS) {
        // day
        label = `${Math.round(absDiff / DAY_IN_MS)}${DAY_LABEL} ${futureLabel}`
      } else if (absDiff < DAY_IN_MS && absDiff >= HOUR_IN_MS) {
        // hour
        label = `${Math.round(
          absDiff / HOUR_IN_MS,
        )}${HOUR_LABEL} ${futureLabel}`
      } else if (absDiff < HOUR_IN_MS && absDiff >= MINUTE_IN_MS) {
        // minute
        label = `${Math.round(
          absDiff / MINUTE_IN_MS,
        )}${MINUTE_LABEL} ${futureLabel}`
      } else if (absDiff < MINUTE_IN_MS && absDiff >= SECOND_IN_MS) {
        // second
        label = `${Math.round(
          absDiff / SECOND_IN_MS,
        )}${SECOND_LABEL} ${futureLabel}`
      }
    } else {
      label = CURRENT_LABEL
    }
  }
  return label
}

const RelativeTimestamp = ({ timestamp, futureDate, relativeDate, futureLabel }) => {
  const theRelativeDate = relativeDate || new Date()
  const now = moment(theRelativeDate)
  const momentDate = moment(timestamp)
  const diff = now.diff(momentDate, 'millisecond')

  return (
    <time
      dateTime={momentDate.toDate()}
      title={momentDate.format('MMMM D, YYYY h:mm A')}
    >
      {_generateTimestampLabel(diff, momentDate, futureDate, futureLabel)}
    </time>
  )
}

RelativeTimestamp.propTypes = {
  // timestamp: PropTypes.instanceOf(Date).isRequired,
  futureDate: PropTypes.bool,
  // useLongLabels
  relativeDate: PropTypes.instanceOf(Date),
  futureLabel: PropTypes.string,
}

RelativeTimestamp.defaultProps = {
  futureLabel: 'from now',
}

export default RelativeTimestamp